// *** REACT components 
import React,{useEffect,useContext} from 'react'
// *** core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js"
import InputAdornment from '@material-ui/core/InputAdornment'
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
// *** Contexto
import {UsuarioContext} from 'config/context/UsuarioProvider'
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator'
// *** Services
import { PlanCompraActions } from "services"

export default function DatosFacturacion() {
  const {usuario, dataEmpresa, setdataEmpresa} = useContext(UsuarioContext);
  var rutRef = React.createRef()
  var celularRef = React.createRef()
  var emailRef = React.createRef()
  var razonSocialRef = React.createRef()
  var direccionRef = React.createRef()
  const [value, setValue] = React.useState(null);
  const [listActividad, setListActividad] = React.useState([]);
  ValidatorForm.addValidationRule('isTruthy', value => value);  
  ValidatorForm.addValidationRule('isRut', (value) => {
    let rutFormateado = formatRut(value,false)    
    return rutEsValido(rutFormateado)
  })
  const defaultProps = {
    options: listActividad,
    getOptionLabel: (option) => option.actividadEconomica,
  };
  const flatProps = {
    options: listActividad.map((option) => option.actividadEconomica),
  };
  
  function formatRut(value, useThousandsSeparator) {
    var rutAndDv = splitRutAndDv(value)
    var cRut = rutAndDv[0]; var cDv = rutAndDv[1]
    if (!(cRut && cDv)) { return cRut || value; }
    var rutF = ""
    var thousandsSeparator = useThousandsSeparator ? "." : ""
    while (cRut.length > 3) {
      rutF = thousandsSeparator + cRut.substr(cRut.length - 3) + rutF
      cRut = cRut.substring(0, cRut.length - 3)
    }
    return cRut + rutF + "-" + cDv
  }

  function splitRutAndDv(rut) {
    var cValue = clearFormat(rut);
    if (cValue.length === 0) { return [null, null]; }
    if (cValue.length === 1) { return [cValue, null]; }
    var cDv = cValue.charAt(cValue.length - 1);
    var cRut = cValue.substring(0, cValue.length - 1);
    return [cRut, cDv];
  }
  function clearFormat(value) {
    return value.replace(/[\.\-]/g, "");
  }
  function rutEsValido(rut) {
    if (!rut || rut.trim().length < 3) return false;
    const rutLimpio = rut.replace(/[^0-9kK-]/g, "");

    if (rutLimpio.length < 3) return false;

    const split = rutLimpio.split("-");
    if (split.length !== 2) return false;

    const num = parseInt(split[0], 10);
    const dgv = split[1];

    const dvCalc = calculateDV(num);
    return dvCalc === dgv.toUpperCase();
  }
  function calculateDV(rut) {
    const cuerpo = `${rut}`;
    // Calcular Dígito Verificador
    let suma = 0;
    let multiplo = 2;

    // Para cada dígito del Cuerpo
    for (let i = 1; i <= cuerpo.length; i++) {
      // Obtener su Producto con el Múltiplo Correspondiente
      const index = multiplo * cuerpo.charAt(cuerpo.length - i);

      // Sumar al Contador General
      suma += index;

      // Consolidar Múltiplo dentro del rango [2,7]
      if (multiplo < 7) {
        multiplo += 1;
      } else {
        multiplo = 2;
      }
    }

    // Calcular Dígito Verificador en base al Módulo 11
    const dvEsperado = 11 - (suma % 11);
    if (dvEsperado === 10) return "K";
    if (dvEsperado === 11) return "0";
    return `${dvEsperado}`;
  }
  useEffect(() => {
    PlanCompraActions.ActividadEconomica().then((response)=>{
      //cargar validar correo  
      setListActividad(response.data)
    })
    if(usuario.selectedEnabledEmpresa===false)
      setdataEmpresa({...dataEmpresa, rut:usuario.rut, email:usuario.email, telefono:usuario.celular,direccion: usuario.direccion});    
  }, []);
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={6} md={6} lg={6} style={{paddingTop: 30}}> 
        <TextValidator 
          fullWidth
          inputProps={{
            maxLength: 12
          }} 
          autoFocus
          ref={rutRef}
          onBlur={e =>rutRef.current.validate(e.target.value)}
          id="txtRUT" 
          label="RUT" 
          type="RUT" 
          value={dataEmpresa.rut}
          onChange={e => setdataEmpresa({...dataEmpresa, rut:formatRut(e.target.value.replace(/[^0-9kK-]/g, ""),true).toUpperCase()})}
          validators={["isTruthy",'isRut',"required"]}
          errorMessages={['Campo requerido o formato incorrecto']}
        /> 
      </GridItem>
        <GridItem xs={12} sm={6} md={6} lg={6} style={{paddingTop: 30}}>        
          <TextValidator 
            fullWidth      
            inputProps={{
              maxLength: 100
              ,style: {textTransform: 'uppercase'}
            }}                       
            ref={razonSocialRef}
            onBlur={e =>razonSocialRef.current.validate(e.target.value)}
            id="txtRAZON_SOCIAL" 
            label="RAZÓN SOCIAL" 
            value={dataEmpresa.razonSocial}
            onChange={e => setdataEmpresa({...dataEmpresa, razonSocial:e.target.value.replace(/[^A-Za-z 0-9#ÑñÁÉÍÓÚáéíóú]+/g, "").toUpperCase()})}
            validators={['minStringLength:5','maxStringLength:100',"required"]}
            errorMessages={['Campo requerido o mínimo 5 y máximo 100 caracteres']}         
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={12} lg={12} style={{paddingTop: 30}}>                
          <Autocomplete            
            noOptionsText='No Existe Coincidencia'
            {...defaultProps}           
            id="txtACTIVIDAD_ECONOMICA"              
            value={dataEmpresa.actividadEconomica}
            onChange={(event, value) => {                  
              setdataEmpresa({...dataEmpresa, actividadEconomica:value,actividadEconomicaError:false})
            }}
            renderInput={(params) => <TextField error={dataEmpresa.actividadEconomicaError} helperText={dataEmpresa.actividadEconomicaError? "Campo requerido": ""} {...params} label="ACTIVIDAD ECONÓMICA" margin="normal" />}
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={6} lg={6} style={{paddingTop: 30}}>            
          <TextValidator 
            fullWidth                 
            ref={emailRef}            
            onBlur={e =>emailRef.current.validate(e.target.value)}
            id="txtCorreo_Electronico" 
            label="Correo Electrónico" 
            value={dataEmpresa.email}
            onChange={e => setdataEmpresa({...dataEmpresa, email:e.target.value})}
            validators={["isTruthy","isEmail","required"]}
            errorMessages={['Campo requerido y con formato correo']}         
            inputProps={{
              style: {textTransform: 'uppercase'}
              ,maxLength: 100
            }} 
          /> 
        </GridItem>
        <GridItem xs={12} sm={6} md={6} lg={6} style={{paddingTop: 30}}>          
          <TextValidator 
            fullWidth                 
            ref={celularRef}
            onBlur={e =>celularRef.current.validate(e.target.value)}
            id="txtCelular" 
            label="Teléfono" 
            type="number" 
            onInput = {(e) =>{e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,9)}} 
            value={dataEmpresa.telefono}
            onChange={e => setdataEmpresa({...dataEmpresa, telefono:e.target.value})}
            validators={["isTruthy","required"]}
            errorMessages={['Campo requerido']}
            InputProps={{
              startAdornment: <InputAdornment position="start">+56-</InputAdornment>,
            }}
          /> 
        </GridItem>
        <GridItem xs={12} sm={12} md={12} lg={12} style={{paddingTop: 30}}>              
          <TextValidator 
            fullWidth     
            inputProps={{
              maxLength: 100
            }}             
            ref={direccionRef}
            onBlur={e =>direccionRef.current.validate(e.target.value)}
            id="txtDireccion" 
            label="Dirección" 
            value={dataEmpresa.direccion}
            onChange={e => setdataEmpresa({...dataEmpresa, direccion:e.target.value.replace(/[^A-Za-z 0-9#ºñÑ]+/g, "").toUpperCase()})}
            validators={['minStringLength:5','maxStringLength:100',"required"]}
            errorMessages={['Campo requerido o mínimo 5 y máximo 100 caracteres']}         
          />
        </GridItem>
      </GridContainer>
    </div>
  )
}